const initialState = { team: [] };
export const teamReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "ADD_TEAM":
      return { ...state, team: payload };
    default:
      return state;
  }
};
